import React, { useState } from 'react';
import {
  Card, Col, Row, Select
} from 'antd';

const IconImg = (props) => (
  <img src={props.name} alt="Vendor Medical" />
)

const { Option } = Select;
export default function CardComponent(props) {

  const [dropDownSurgeryValue, setDropDownSurgeryValue] = useState('today');

  const cardSurgeryTitle = (
    <Row className="card-title">
      <Col span={8} className="icon-bg">
        <div><IconImg name={props.OrdersIcon} /></div>
      </Col>
      <Col span={16} className="title-content">
        <>
          {dropDownSurgeryValue === 'today' && (
            <>
              <p>Surgery Consultation</p>
              <span>{props.data.surgery_consultation && props.data.surgery_consultation.today.total_count}</span>
            </>
          )}
          {dropDownSurgeryValue === 'week' && (
            <>
              <p>Surgery Consultation</p>
              <span>{props.data.surgery_consultation && props.data.surgery_consultation.week.total_count}</span>
            </>
          )}
          {dropDownSurgeryValue === 'month' && (
            <>
              <p>Surgery Consultation</p>
              <span>{props.data.surgery_consultation && props.data.surgery_consultation.month.total_count}</span>
            </>
          )}
        </>
      </Col>
    </Row>
  )

  const surgeryDropdown = (
    <span className='select-button'>
      <Select defaultValue="today" style={{ width: 111 }} onChange={(value) => setDropDownSurgeryValue(value)}>
        <Option value="today">Today</Option>
        <Option value="week">This Week</Option>
        <Option value="month">This Month</Option>
      </Select>
    </span>
  )

  return (
    props.data ? (
      <Card bordered={false} title={cardSurgeryTitle} className='dashboard-card' extra={surgeryDropdown}>
        {dropDownSurgeryValue === 'today' && (
          <>
            <p className='card-component-content'>Completed: <span>{props.data.surgery_consultation.today.completed}</span></p>
            <p className='card-component-content'>Cancelled: <span>{props.data.surgery_consultation.today.cancelled}</span></p>
            <p className='card-component-content'>New Booking: <span>{props.data.surgery_consultation.today.new}</span></p>
          </>
        )}
        {dropDownSurgeryValue === 'week' && (
          <>
            <p className='card-component-content'>Completed: <span>{props.data.surgery_consultation.week.completed}</span></p>
            <p className='card-component-content'>Cancelled: <span>{props.data.surgery_consultation.week.cancelled}</span></p>
            <p className='card-component-content'>New Booking: <span>{props.data.surgery_consultation.week.new}</span></p>
          </>
        )}
        {dropDownSurgeryValue === 'month' && (
          <>
            <p className='card-component-content'>Completed: <span>{props.data.surgery_consultation.month.completed}</span></p>
            <p className='card-component-content'>Cancelled: <span>{props.data.surgery_consultation.month.cancelled}</span></p>
            <p className='card-component-content'>New Booking: <span>{props.data.surgery_consultation.month.new}</span></p>
          </>
        )}
      </Card>
    ) : null
  );
}
